/* Change this file to get your personal Porfolio */
import experienceData from './shared/experience_data.json';
import degreesData from './shared/degrees_data.json';
import majorProjectsData from './shared/major_projects_data.json';
import skillsData from './shared/skills_data.json';

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

const degrees = degreesData || {
  degrees: []
};

const experience = experienceData || {
  experience: []
};
const majorProjects = majorProjectsData || {
  projects: []
};

const skills = skillsData || {
  data: []
};

//SEO Related settings
const seo = {
  title: "Lakhdeep Singh Jawandha — Senior iOS Mobile Engineer & Team Lead",
  description: "Senior iOS Mobile Engineer & Team Lead in Melbourne. 10+ years and 25+ App Store apps shipped — 2 ranked Top 10 in the US. Swift, SwiftUI, Objective-C, React Native, KMM, Metal, AVFoundation.",
  keywords: [
    "Lakhdeep Singh Jawandha",
    "Senior iOS Engineer",
    "iOS Team Lead",
    "Swift Developer Melbourne",
    "SwiftUI Developer",
    "React Native Developer",
    "Objective-C Developer",
    "Mobile App Developer Melbourne",
    "ShareChat iOS Engineer",
    "App Store Top 10 Developer",
    "KMM Developer",
    "iOS Architect"
  ].join(", "),
  author: "Lakhdeep Singh Jawandha",
  image: "https://lakhdeep.vercel.app/assets/images/profile.jpg",
  url: "https://lakhdeep.vercel.app/",
  og: {
    title: "Lakhdeep Singh Jawandha — Senior iOS Mobile Engineer & Team Lead",
    type: "website",
    url: "https://lakhdeep.vercel.app/",
    image: "https://lakhdeep.vercel.app/assets/images/profile.jpg",
    description: "10+ years building iOS and React Native apps. 25+ App Store releases, 2 ranked Top 10 in the US, serving millions at 99% crash-free. Currently building cross-platform streaming at Sparkview, Melbourne.",
    siteName: "Lakhdeep Singh Jawandha Portfolio"
  },
  twitter: {
    card: "summary_large_image",
    site: "@LakhdeepJawand1",
    creator: "@LakhdeepJawand1",
    title: "Lakhdeep Singh Jawandha — Senior iOS Mobile Engineer & Team Lead",
    description: "10+ years, 25+ App Store apps shipped — 2 ranked Top 10 in the US. Swift, SwiftUI, React Native.",
    image: "https://lakhdeep.vercel.app/assets/images/profile.jpg"
  }
};

//Home Page
const greeting = {
  title: "Lakhdeep Singh Jawandha",
  logo_name: "Lakhdeep",
  nickname: "",
  subTitle:
    "Senior iOS Mobile Engineer & Team Lead. Shipped 25+ apps to the App Store — 2 ranked Top 10 in the US — serving millions at 99% crash-free. Now building cross-platform streaming at Sparkview, Melbourne.",
  resumeLink:
    "https://drive.google.com/file/d/1OyCpD-mLI3D3PGDj2b0kO6Xdl_Dymbq_/view",
  portfolio_repository: "https://github.com/lakhdeepjawandha/Lakhdeep-Master-Portfolio",
  githubProfile: "https://github.com/lakhdeepjawandha",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/lakhdeepjawandha",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/lakhdeepsingh/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: " ",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Stack Overflow",
    link: "https://stackoverflow.com/users/5238957/lakhdeep-singh",
    fontAwesomeIcon: "fa-brands fa-stack-overflow", // Reference https://fontawesome.com/icons/stack-overflow?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Shadertoy",
  //   link: "https://www.shadertoy.com/user/lakhdeep92",
  //   fontAwesomeIcon: "fa-google",
  //   backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  // },
  {
    name: "Gmail",
    link: "mailto:lakhdeepjawandha@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/LakhdeepJawand1",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/lakhdeepjawandha/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/lakhdeepjawandha",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/lakhdeep",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@lakhdeepjawandha1",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/lakhdeepjawandha",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
  ],
};

// Replace your current experience object with:
// const experience = experienceData;
// const experience = experienceData || {
//   title: "Experience",
//   subtitle: "Work, Internship and Volunteership", 
//   description: "Loading experience data...",
//   sections: []
// };

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A selection of iOS apps shipped to the App Store — from large-scale social platforms to focused photo, video, and PDF utilities. Most lean heavily on Swift, Objective-C, AVFoundation, Core Image, Metal, and OpenGL for real-time media features.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "neuro-symbolic-sudoku-solver",
    //   name: "Neuro-Symbolic Sudoku Solver",
    //   createdAt: "2023-07-02T00:00:00Z",
    //   description: "Paper published in KDD KiML 2023",
    //   url: "https://arxiv.org/abs/2307.00653",
    // },
    // {
    //   id: "mdp-diffusion",
    //   name: "MDP-Diffusion",
    //   createdAt: "2023-09-19T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/mdp-diffusion/",
    // },
    // {
    //   id: "consistency-models",
    //   name: "Consistency Models",
    //   createdAt: "2023-10-12T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/consistency-models/",
    // },
  ],
};

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_profile.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I’m available to assist with iOS development, ML, AI, React, React Native, Android, Python and Cloud.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://medium.com/@lakhdeep",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Melbourne, Australia",
    locality: "Melbourne",
    country: "Australia",
    region: "Victoria",
    // postalCode: "95129",
    // streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/MkoMDvrrBjhuy2Bq9",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  majorProjects,
  publicationsHeader,
  publications,
  contactPageData,
};
